import React from "react";
import "./mathuraStyle.css";
import CustomNav from "../components/CustomNav";
import TypeIt from "typeit-react";
import BasicModal from "../components/Modal";
import Footer from "../components/Footer";
import Breadcrum from "../components/Breadcrum";

function Mathura() {
  return (
    <>
      {/* <CustomNav /> */}
      <Breadcrum ghat="Mathura"/>
      <div className="var-heading-container">
        <TypeIt>
          <h1 className="var-heading">Mathura</h1>
        </TypeIt>
      </div>
      <div className="container">
        <div className="image-container">
          <img
            src="https://dynamic-media-cdn.tripadvisor.com/media/photo-s/03/05/a4/03/vishram-ghat.jpg?w=900&h=600"
            alt=""
            style={{ boxShadow: "0 0 10px 10px rgba(255, 119, 0, 0.5);" }}
          />
        </div>
        <div className="text-container">
          <p>
            <h1>Vishram Ghat</h1>
            Believed to be one of the oldest ghats in the city, it is steeped in
            religious and cultural importance.
            <BasicModal
              title="Vishram Ghat"
              description=" According to legends, this is the very site where the revered Hindu philosopher and saint, Adi Shankara, took rest (vishram) during his travels, giving the ghat its name.

              Vishram Ghat is a popular destination for devotees to perform sacred rituals and ceremonies. Pilgrims flock to the ghat to take a purifying dip in the holy waters of the Ganges, offer prayers, and conduct last rites for their departed loved ones. The ghat is adorned with intricate stone carvings, sculptures, and shrines dedicated to various Hindu deities, showcasing the rich architectural heritage of the region.
              
              During major Hindu festivals like Ganga Dussehra and the auspicious Kumbh Mela, Vishram Ghat becomes a vibrant hub of cultural activities, hosting religious gatherings, music, and dance performances that attract devotees and tourists from far and wide. Like many other ghats in Haridwar, Vishram Ghat witnesses the mesmerizing Ganga Aarti (river worship ceremony) every evening, where priests perform rituals with lit lamps, bells, and chants, creating a spiritual and enchanting atmosphere."
            />
          </p>
        </div>
      </div>

      <div className="container">
        <div className="image-container-left">
          <img
            src="https://static.toiimg.com/thumb/msid-50818294,width-1024,height-720/50818294.jpg"
            alt=""
          />
        </div>
        <div className="text-container-left">
          <p>
            <h1>Keshi Ghat</h1>
            This ancient ghat holds a special place in the cultural and
            spiritual fabric of the city.
            <BasicModal
              title="Kushavarta Ghat"
              description="According to Hindu mythology, Keshi Ghat is believed to be the site where Lord Krishna slayed the demon Keshi, who had taken the form of a powerful horse. This event is narrated in the Bhagavata Purana, one of the most revered Hindu scriptures. As a result, Keshi Ghat is considered a sacred and auspicious place for devotees of Lord Krishna.

              The ghat features intricate stone carvings and sculptures depicting scenes from Hindu mythology, showcasing the rich artistic heritage of the region. Pilgrims and devotees throng to Keshi Ghat to take a purifying dip in the holy waters of the Ganges and offer prayers to Lord Krishna and other deities.
              
              "
            />
          </p>
        </div>
      </div>
      <div className="container">
        <div className="image-container">
          <img
            src="https://mathuravrindavantourism.co.in/images/places-to-visit/headers/sri-krishna-janmasthan-mathura-tourism-entry-fee-timings-holidays-reviews-header.jpg"
            alt=""
          />
        </div>
        <div className="text-container">
          <p>
            <h1>Krishna Janmasthan Ghat</h1>
            Steeped in Hindu mythology and religious significance, this ghat
            holds a special place in the hearts of devotees of Lord Krishna.
            <BasicModal
              title="Asthi Pravah Ghat"
              description="According to legends, this is the very site where Lord Krishna is believed to have been born during his incarnation on Earth. The ghat derives its name from the Sanskrit words Krishna Janmasthan, which translates to the birthplace of 'Lord Krishna'.

              The ghat features an ancient temple dedicated to Lord Krishna, adorned with intricate carvings and sculptures depicting scenes from Hindu mythology and the life of the beloved deity. Pilgrims and devotees from across India and around the world flock to this ghat to offer prayers, perform rituals, and seek blessings from Lord Krishna.
              
              During the auspicious festival of Janmashtami, which celebrates the birth of Lord Krishna, Krishna Janmasthan Ghat becomes a vibrant hub of festivities. Devotees gather in large numbers to participate in cultural programs, sing devotional songs (bhajans), and witness the mesmerizing Ganga Aarti (river worship ceremony) that takes place every evening.
              
              With its profound religious significance, architectural beauty, and vibrant cultural atmosphere, Krishna Janmasthan Ghat is not only a revered pilgrimage site but also a popular tourist attraction in Haridwar. It stands as a testament to the city's rich spiritual heritage and its deep connection to the divine life and teachings of Lord Krishna, making it an integral part of Haridwar's identity and a must-visit destination for those seeking spiritual solace and cultural enrichment."
            />
          </p>
        </div>
      </div>
      <div className="container">
        <div className="image-container-left">
          <img
            src="https://qph.cf2.quoracdn.net/main-qimg-bb3f988a00a48250106e18dcc9ad7609-lq"
            alt=""
          />
        </div>
        <div className="text-container-left">
          <p>
            <h1>Dashashwamedh Ghat</h1>
            This ancient ghat holds a special place in Hindu mythology and is
            considered one of the most sacred sites in the city.
            <BasicModal
              title="Subhash Ghat"
              description="According to legend, the name 'Dashashwamedh' is derived from the Sanskrit words 'dashashwa' meaning 'ten horses' and 'medh' meaning 'sacrifice.' It is believed that Lord Brahma, the creator of the universe in Hindu mythology, performed a sacred ritual here by sacrificing ten horses to please the gods and obtain their blessings.

The ghat features intricate stone carvings, sculptures, and shrines dedicated to various Hindu deities, showcasing the rich architectural heritage of the region. Pilgrims and devotees flock to Dashashwamedh Ghat to take a purifying dip in the holy waters of the Ganges, offer prayers, and perform religious rituals and ceremonies.

During major Hindu festivals like Ganga Dussehra and Kumbh Mela, Dashashwamedh Ghat becomes a hub of vibrant cultural activities, hosting religious gatherings, music, and dance performances that attract devotees and tourists from far and wide.

Like many other ghats in Haridwar, Dashashwamedh Ghat witnesses the mesmerizing Ganga Aarti (river worship ceremony) every evening, where priests perform rituals with lit lamps, bells, and chants, creating a spiritual and enchanting atmosphere that captivates the hearts of spectators.

With its deep-rooted religious significance, architectural splendor, and cultural vibrancy, Dashashwamedh Ghat is not only a revered pilgrimage site but also a popular tourist attraction in Haridwar. It stands as a testament to the city's rich spiritual heritage and mythological traditions, making it an integral part of Haridwar's identity and a must-visit destination for those seeking to experience the essence of Hindu culture and spirituality."
            />
          </p>
        </div>
      </div>
      <div className="container">
        <div className="image-container">
          <img
            src="https://staticimg.amarujala.com/assets/images/2018/10/17/vijayadashami-2018_1539763639.jpeg?w=674&dpr=1.0"
            alt=""
          />
        </div>
        <div className="text-container">
          <p>
            <h1>Ravan Koti Ghat</h1>
            This ancient ghat holds a special place in the epic Hindu mythology
            of Ramayana.{" "}
            <BasicModal
              title="Asthi Pravah Ghat"
              description="According to the legendary tale, it is believed that this is the very site where the demon king Ravana, the antagonist of the Ramayana, performed severe penance and austerities to please Lord Shiva and seek his blessings. The name 'Ravan Koti' is derived from the Sanskrit words 'Ravan' (the demon king) and 'Koti' (a large number or crore), referring to the sheer intensity of Ravana's penance at this ghat.

              The ghat features intricate stone carvings, sculptures, and shrines depicting scenes from the Ramayana, showcasing the rich artistic heritage and storytelling traditions of the region. Pilgrims and devotees visit Ravan Koti Ghat to offer prayers, perform religious rituals, and seek blessings from the divine forces.
              
              During major Hindu festivals, particularly those associated with the Ramayana, such as Dussehra and Ram Navami, Ravan Koti Ghat becomes a hub of vibrant cultural activities. Devotees gather here to participate in cultural programs, enactments of scenes from the epic, and witness the mesmerizing Ganga Aarti (river worship ceremony) that takes place every evening.
              
              With its deep-rooted mythological significance, architectural beauty, and cultural vibrancy, Ravan Koti Ghat is not only a revered pilgrimage site but also a popular tourist attraction in Haridwar. It stands as a testament to the city's rich spiritual heritage, its connection to the epic Ramayana, and the artistic traditions that have kept these stories alive for generations, making it an integral part of Haridwar's identity and a must-visit destination for those seeking to immerse themselves in the vibrant tapestry of Hindu mythology and culture."
            />
          </p>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <Footer />
    </>
  );
}

export default Mathura;
